import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { PHONE, PHONE_TEL } from "../data/content";

export default function Retired() {
  return (
    <>
      <SEO
        title="Page No Longer Available | Tech Emergency"
        description="This page is no longer available. Tech Emergency provides residential computer repairs and home IT support across Adelaide."
        noIndex
      />
      <section className="pt-16 pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="te-overline mb-4">/ 410 — Page retired</div>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tighter mb-4" data-testid="retired-heading">
            This page is no longer available.
          </h1>
          <p className="text-zinc-400 mb-8">
            Tech Emergency now focuses exclusively on residential computer repairs and home IT
            support across metropolitan Adelaide.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a href={PHONE_TEL} className="te-btn te-btn-primary" data-testid="retired-call-btn">
              <Phone size={16} /> Call {PHONE}
            </a>
            <Link to="/services" className="te-btn te-btn-ghost" data-testid="retired-services-btn">
              See our home IT services <ArrowRight size={15} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
